import React from "react";
import CotizacionFormPage from "../component/Cotizacion/CotizacionFormPage";

const CotizacionEditar = () => <CotizacionFormPage mode="edit" />;

export default CotizacionEditar;
